import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { HeaderView } from "../HeaderView/HeaderView";
import { FooterLinks } from "../FooterLinks/FooterLinks";
import { SocialView } from "../SocialView/SocialView";
import { FooterNote } from "../FooterLinks/FooterNote";
import { SearchView } from "../SearchView/SearchView";
import { initialize } from "redux-form";
import NewsletterForm from "../HomeView/NewsletterForm";
import Helmet from "react-helmet";

import {
  fetchMenusIfNeeded,
  sendNewletterRequest,
  setShowNewsLetterForm,
  CLIENT_BASE_URL
} from "../../actions";

export class NewsletterView extends React.Component {
  state = {
    showNewsLetterFrom: false,
    successMsg: ""
  };

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(setShowNewsLetterForm(true));
    this.setState({
      showNewsLetterFrom: true
    });
  }
  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(fetchMenusIfNeeded(this.props.selectedScope));
    window.addEventListener("resize", this.onResize);

    this.onResize();
  }

  componentWillReceiveProps(nextProps) {
    const { match, dispatch } = nextProps;
    if (match !== this.props.match) {
      dispatch(fetchMenusIfNeeded(nextProps.selectedScope));
    }

    if (
      nextProps.showNewsLetterFrom !== this.props.showNewsLetterFrom &&
      !nextProps.showNewsLetterFrom
    ) {
      this.setState({
        successMsg: `Obrigado por subscrever a newsletter.\nEm breve começará a receber regularmente as nossas publicações.`
      });

      clearTimeout(this.nletterFormTmr);
      this.nletterFormTmr = setTimeout(() => {
        this.setState({
          showNewsLetterFrom: nextProps.showNewsLetterFrom
        });
      }, 3000);
    }
  }

  onResize = () => {
    console.log("onResize", window.innerHeight);
  };

  handleSubmitNewsletter = req => {
    const { dispatch } = this.props;
    // chamar uma acção para fazer o post dos dados
    console.log("handleSubmitNewsletter", req);

    dispatch(sendNewletterRequest(req));

    const initialFormData = ["email", "city"];

    dispatch(
      initialize(
        "contact",
        {
          email: "",
          city: ""
        },
        initialFormData
      )
    ); // clear form
  };

  gotoPage = page => {
    this.props.history.push("/pesquisa");
  };

  render() {
    const { menus, dispatch } = this.props;
    const bottom_menus = menus.bottom || [];
    const top_menus = menus.top || [];

    return (
      <div>
        <Helmet
          title="Newsletter"
          meta={[
            {
              name: "description",
              content:
                "A Festa do Cinema Italiano é o acontecimento mais importante em Portugal dedicado à cultura italiana e um dos festivais cinematográficos mais apreciados no país. Organizado pela Associação Il Sorpasso desde 2008, a Festa do Cinema Italiano ampliou também a sua presença internacionalmente com extensões e programação a decorrer em países como Brasil, Angola e Moçambique."
            },
            {
              property: "og:image",
              content:
                "https://festadocinemaitaliano.com/admin/assets/img/logo.png"
            },
            { property: "og:title", content: "Newsletter" },
            { property: "og:type", content: "article" },
            {
              property: "og:url",
              content: CLIENT_BASE_URL + "/newsletter"
            }
          ]}
        />
        <HeaderView top_menus={top_menus} dispatch={dispatch} />

        <div id="newsletter-view" className="row team-view">
          <div
            className="col-md-12 no-pad text-left"
            style={{ position: "relative" }}
          >
            <p className="left-tag">Newsletter</p>
            <SearchView
              gotoPage={this.gotoPage}
              dispatch={dispatch}
              customStyle={"alignright"}
            />
          </div>
          <div className="row main-block">
            <div className="col-lg-12 text-center">
              <div>
                <NewsletterForm
                  inClassName="on"
                  onSubmit={this.handleSubmitNewsletter}
                  successMsg={this.state.successMsg}
                  standalone={true}
                />
              </div>
            </div>
            <div className="col-sm-8 col-md-offset-1 col-md-6 col-lg-5">
              <div className="txt-block" />
            </div>
          </div>
        </div>

        <FooterLinks bottom_menus={bottom_menus} />
        <SocialView customclass="lite" />
        <FooterNote />
      </div>
    );
  }
}

NewsletterView.propTypes = {
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  menus: PropTypes.any.isRequired,
  selectedScope: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  const { getMenus, selectedScope, showNewsLetterFrom } = state;

  const { isFetchingMenus, lastUpdatedMenus, items: menus } = getMenus[
    selectedScope
  ] || {
    isFetchingMenus: true,
    items: []
  };

  return {
    isFetchingMenus,
    lastUpdatedMenus,
    menus,
    selectedScope,
    showNewsLetterFrom
  };
}

export default withRouter(connect(mapStateToProps)(NewsletterView));



// WEBPACK FOOTER //
// ./src/views/AboutView/NewsletterView.js